export function requestTimeout(controller: AbortController, timeout: number) {
	let cancelled = false;

	const t = setTimeout(() => {
		if (!cancelled && !controller.signal.aborted) {
			controller.abort();
		}
	}, timeout);

	return function cancelTimeout() {
		clearTimeout(t);
		cancelled = true;
	};
}
